export const addVehiclesLabel = {
    HEADER_TEXT: "Vehicle Selection",
    SUB_HEADER_TEXT:
    "Please select the Make, Range or Trim that are to be added to the campaign. If multiple makes are selected then range and trim are unavailable.",
  };
  
  